// src/app/text-loader.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageLoaderService {
  constructor(private http: HttpClient) {}

  // Method to load text from assets
  loadTextFromAssets(): Observable<string> {
    return this.http.get('assets/noto-serif-jp.txt', { responseType: 'text' });
  }

  loadTextFromAssetsAL(): Observable<string> {
    return this.http.get('assets/jap-b64.txt', { responseType: 'text' });
  }

  loadCyrillicFontFromAssets(): Observable<string> {
    return this.http.get('assets/inter-regular-cyrillic.txt', { responseType: 'text' });
  }

  // Fallback method to load Inter font directly
  loadInterFontFromAssets(): Observable<string> {
    return this.http.get('assets/fonts/Inter-Regular.ttf', { responseType: 'text' });
  }
}
